


































import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import { deepClone } from 'lodash';
import * as service from '@/services/users';
import * as UpdateUserData$ from '@/subjects/update-user-data';
import BaseComponent from '@/components/base-component.vue';
import UiDisablePasswordAutofill from '@/components/UI/disable-password-autofill.vue';
import CurrentUserModel from '@/models/current-user-model';
import {
  USER_TYPE_OTHER,
  USER_TYPE_DOCTOR,
  ACCESS_TYPE_CLIENT,
} from '@/settings/consts/users';
import { validEmail } from '@/helpers/validEmail';
import { ICurrentUser } from '@/interfaces/user';
import {
  getLocalUser,
  getSessionData,
  setLocalUser,
} from '@/services/session-data';
import Parameters from '@/views/parameters/screens/index.vue';
import {
  ERROR_CODE_DUPLICATE,
  ERROR_CODE_BAD_REQUEST,
} from '@/settings/consts/api-error';

@Component({
  components: { UiDisablePasswordAutofill },
})
export default class UpdateCurrentUserForm extends BaseComponent {
  public form: any = {
    valid: false,
    rules: {
      phone: [(v) => !!v || 'Digite um telefone'],
      cellphone: [(v) => !!v || 'Digite um celular'],
      newPassword: [
        (v) =>
          !v ||
          (!!v && /\d/g.test(v)) ||
          'A senha precisa ter pelo menos um numero',
        (v) =>
          !v ||
          (!!v && /[A-Z]/g.test(v)) ||
          'A senha precisa ter pelo menos um caractere maiúsculo',
        (v) =>
          !v ||
          (!!v && /[a-z]/g.test(v)) ||
          'A senha precisa ter pelo menos um caractere minúsculo',
        (v) =>
          !v ||
          (!!v && /[^\w\d]/g.test(v)) ||
          'A senha precisa ter pelo menos um caractere especial',
        (v) =>
          !v ||
          (!!v && v.length > 5) ||
          'A senha precisa ter no mínimo 6 caracteres',
      ],
      email: [
        (v) => !!v || 'Digite o e-mail',
        (v) => !v || validEmail(v) || 'Digite um e-mail válido.',
      ],
    },
  };

  public $refs!: {
    form: HTMLFormElement;
  };

  public item: CurrentUserModel = new CurrentUserModel();
  public userTypes = {
    doctor: USER_TYPE_DOCTOR,
    other: USER_TYPE_OTHER,
  };

  public beforeMount(): void {
    this.load();
  }

  public isDoctor(): boolean {
    return this.item.tipoLogin === this.userTypes.doctor;
  }

  public saveItem(): void {
    this.$refs.form.validate();
    if (!this.form.valid || !this.item.validate()) {
      this.toast.show('Ocorreu um erro na validação dos dados', 'error');
      return;
    }

    this.loader.start('Salvando registro...');
    const item = this.item.toJson();

    service.updateCurrentUser(item).subscribe(
      (data) => {
        getLocalUser().subscribe((localUser) => {
          UpdateUserData$.update();

          this.item.senha = '';
          this.item.novaSenha = '';
          this.item.novaSenhaConfirma = '';

          this.loader.stop();
          this.$emit('save');
          this.$refs.form.resetValidation();
          this.toast.show('Dados atualizados com sucesso.', 'success');
        });
      },
      (error) => {
        this.loader.stop();
        if ((error.status === ERROR_CODE_BAD_REQUEST || error.data.message.length) && error.data.message !== 'No message available') {
          this.toast.show(error.data.message, 'error');
        } else {
          this.toast.show('Ocorreu um erro ao atualizar os dados', 'error');
        }
      },
    );
  }

  private load(): void {
    getSessionData().subscribe((data) => {
      const payload = {
        id: data.idLogin,
        tipoLogin: data.tipoUsuario,
        tipoAcesso: data.tipoAcesso,
        idMedico: null,
        idUsuario: null,
        nome: null,
        email: null,
        cpf: null,
        crm: null,
        crmUF: null,
        telefone: null,
        celular: null,
      };

      if (data.tipoUsuario === USER_TYPE_DOCTOR) {
        payload.idMedico = data.medico.id;
        payload.nome = data.medico.nome;
        payload.email = data.medico.email;
        payload.crm = data.medico.crm;
        payload.crmUF = data.medico.crmUF;
        payload.telefone = data.medico.telefone;
        payload.celular = data.medico.celular;
      } else {
        payload.idUsuario = data.usuario.id;
        payload.nome = data.usuario.nome;
        payload.email = data.usuario.email;
        payload.cpf = data.usuario.cpf;
      }

      this.item = new CurrentUserModel(payload);
    });
  }
}
